export default __webpack_public_path__ + "static/img_interviewee_sychoi@2x-acf8fca03f9b525fec75647d68c8f9c5.png";